<!--
 * @Description:
 * @Author: mdb
 * @Date: 2023-04-13 13:53:26
 * @LastEditTime: 2023-04-19 15:49:02
 * @LastEditors: mdb
-->
<template>
  <CardManage :permission="permission" subdomain="lbu" />
</template>

<script setup lang="ts">
import CardManage from '@/views/marketing/marketingManage/cardManage/index.vue'

const permission = {
  add: 'lbu_card_add_btn',
  edit: 'lbu_card_edit_btn',
  del: 'lbu_card_del_btn',
  qrcode: 'lbu_card_qrcode_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuCardManage' }
</script>

<style scoped></style>
